// extracted by mini-css-extract-plugin
export default {"wrapper":"cz-z","viewport":"dz-z","container":"ez-z","slide":"fz-z"};